import { webtoons } from '@/mocks/webtoons';

const rankings = webtoons
  .sort((a, b) => b.rating - a.rating)
  .slice(0, 10);

export default function RankingSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">
              人气排行榜
            </h2>
            <div className="space-y-2">
              {rankings.map((webtoon, index) => (
                <a
                  key={webtoon.id}
                  href={`/article/${webtoon.id}`}
                  className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-200/60 transition-colors group cursor-pointer"
                >
                  <span className={`w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold whitespace-nowrap ${
                    index < 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="w-10 h-14 rounded overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={webtoon.cover}
                      alt={webtoon.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {webtoon.title}
                    </h3>
                    <p className="text-xs text-foreground-600 mt-0.5">{webtoon.author}</p>
                  </div>
                  <div className="flex items-center gap-1 text-primary-500 whitespace-nowrap">
                    <i className="ri-star-fill text-xs"></i>
                    <span className="text-sm font-semibold">{webtoon.rating}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">
              热门标签
            </h2>
            <div className="flex flex-wrap gap-2">
              {Array.from(new Set(webtoons.flatMap((w) => w.tags))).map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-2 text-sm bg-background-200 text-foreground-700 rounded-full hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6 mt-8">
              阅读须知
            </h2>
            <div className="space-y-3 text-sm text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-900">免费阅读：</strong>
                本站所有韩国漫画资源均免费提供，无需注册即可在线阅读。
              </p>
              <p>
                <strong className="text-foreground-900">及时更新：</strong>
                与韩国同步更新，让您第一时间看到最新话内容。
              </p>
              <p>
                <strong className="text-foreground-900">多设备支持：</strong>
                完美适配电脑、平板和手机，随时随地畅享阅读。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}